import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const NewsManagementDetails = () => {
  const { id } = useParams();
  const [news, setNews] = useState({});
  const [error, setError] = useState({ edit: "", content: "", image: "" });
  const [contents, setContents] = useState([]);
  const [addContent, setAddContent] = useState({
    title_en: "",
    title_fr: "",
    title_de: "",
    title_it: "",
    title_es: "",
    content_en: "",
    content_fr: "",
    content_de: "",
    content_it: "",
    content_es: "",
  });
  const imageRef = React.createRef();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const reloadNews = () => {
    fetch(`/api/news/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setNews(data);
        setContents(data.content);
        if (imageRef.current) {
          imageRef.current.src = data.image;
        }
      });
  };


  useEffect(() => {
    reloadNews();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ id ]);

  const handleDeleteNews = (e) => {
    e.preventDefault();
    if (!window.confirm("Are you sure you want to delete this news?")) {
      return;
    }
    fetch(`/api/news/${id}`, {
      method: "DELETE",
    }).then(() => {
      window.location.href = "/admin/news";
    });
  };

  const imageToBase64 = (image) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(image);
    });
  };

  const handleImageClick = (e) => {
    e.preventDefault();
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.addEventListener("change", async function (e) {
      const file = e.target.files[0];
      fetch(`/api/news/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          image: await imageToBase64(file),
          image_type: file.type,
        }),
      }).then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          if (imageRef.current) {
            imageRef.current.src = data.image;
          }
          setError({ ...error, image: "" });
          news.image_type = data.image_type
        } else {
          setError({ ...error, image: data.detail });
        }
      });
    });
  };

  const handleDeleteContent = async (contentId) => {
    if (!window.confirm("Are you sure you want to delete this news content ?")) {
      return;
    }
    const response = await fetch(`/api/news/${id}/content/${contentId}`, {
      method: "DELETE",
    });
    if (response.status === 204) {
      setContents(contents.filter((c) => c.id !== contentId));
      setError({ ...error, content: "" });
    } else {
      const data = await response.json();

      setError({ ...error, content: data.detail });
    }
  };

  const handleAddContent = async (e) => {
    e.preventDefault();
    const response = await fetch(`/api/news/${id}/content`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addContent),
    });
    if (response.ok) {
      setAddContent({
        title_en: "",
        title_fr: "",
        title_de: "",
        title_it: "",
        title_es: "",
        content_en: "",
        content_fr: "",
        content_de: "",
        content_it: "",
        content_es: "",
      });
      reloadNews();
      setError({ ...error, content: "" });
    } else {
      const data = await response.json();
      setError({ ...error, content: data.detail });
    }
  }

  const handleEditNews = async (e) => {
    e.preventDefault();
    const updatedNews = {
      ...news,
      [e.target.name]: e.target.value,
    };
    setNews(updatedNews);

    const response = await fetch(`/api/news/${id}`, {
      method: "PATCH",
      headers: {
      "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedNews),
    });
    if (response.status === 200) {
      setError({ ...error, edit: "" });
    } else {
      const data = await response.json();
      setError({ ...error, edit: data.detail });
    }
  }

  const handleEditNewsContent = async (e, newContentId) => {
    e.preventDefault();
    const updatedContent = {
      ...contents.find((content) => content.id === newContentId),
      [e.target.name]: e.target.value,
    };
    setContents(
      contents.map((content) =>
        content.id === newContentId ? updatedContent : content
      )
    );

    const response = await fetch(`/api/news/${id}/content/${newContentId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedContent),
    });
    if (response.status === 200) {
      setError({ ...error, content: "" });
    } else {
      const data = await response.json();
      setError({ ...error, content: data.detail });
    }
  }

  return (
    <div className="p-4 bg-black text-white">
      <button
        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-4"
        type="button"
        onClick={() => (window.location.href = "/admin/news")}
      >
        Go Back
      </button>
      <div id="edit-news" className="mb-4">
        <label
          htmlFor="news-title-en"
          className="block text-sm font-medium text-white"
        >
          Title (EN):
        </label>
        <input
          type="text"
          id="news-title-en"
          name="title_en"
          value={news.title_en}
          onChange={(e) => handleEditNews(e)}
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="news-title-fr"
          className="block text-sm font-medium text-white"
        >
          Title (FR):
        </label>
        <input
          type="text"
          id="news-title-fr"
          name="title_fr"
          value={news.title_fr}
          onChange={(e) => handleEditNews(e)}
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="news-title-de"
          className="block text-sm font-medium text-white"
        >
          Title (DE):
        </label>
        <input
          type="text"
          id="news-title-de"
          name="title_de"
          value={news.title_de}
          onChange={(e) => handleEditNews(e)}
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="news-title-it"
          className="block text-sm font-medium text-white"
        >
          Title (IT):
        </label>
        <input
          type="text"
          id="news-title-it"
          name="title_it"
          value={news.title_it}
          onChange={(e) => handleEditNews(e)}
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="news-title-es"
          className="block text-sm font-medium text-white"
        >
          Title (ES):
        </label>
        <input
          type="text"
          id="news-title-es"
          name="title_es"
          value={news.title_es}
          onChange={(e) => handleEditNews(e)}
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <div className="text-red-500 text-sm mt-2" id="news-edit-error">
          {error.edit}
        </div>
      </div>

      <button
        id="delete-news"
        onClick={handleDeleteNews}
        className="mb-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
      >
        Delete
      </button>

      <h1 className="text-xl font-semibold mb-4">Content</h1>
      <table className="min-w-full divide-y divide-gray-200 mb-4">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              SubTitle (EN)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              SubTitle (FR)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              SubTitle (DE)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              SubTitle (IT)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              SubTitle (ES)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Content (EN)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Content (FR)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Content (DE)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Content (IT)
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Content (ES)
            </th>
            <th
              colSpan="2"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {contents.map((content) => (
            <tr key={content.id}>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="title_en"
                  value={content.title_en}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="title_fr"
                  value={content.title_fr}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="title_de"
                  value={content.title_de}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="title_it"
                  value={content.title_it}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="title_es"
                  value={content.title_es}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="content_en"
                  value={content.content_en}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="content_fr"
                  value={content.content_fr}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="content_de"
                  value={content.content_de}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="content_it"
                  value={content.content_it}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="text"
                  name="content_es"
                  value={content.content_es}
                  onChange={(e) => handleEditNewsContent(e, content.id)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  type="button"
                  onClick={() => handleDeleteContent(content.id)}
                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <form id="add-content" className="mb-4" onSubmit={handleAddContent}>
        <label
          htmlFor="content-title"
          className="block text-sm font-medium text-white"
        >
          SubTitle (EN):
        </label>
        <input
          type="text"
          id="content-title-en"
          name="subtitle"
          value={addContent.title_en}
          onChange={(e) =>
            setAddContent({ ...addContent, title_en: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="content-title"
          className="block text-sm font-medium text-white"
        >
          SubTitle (FR):
        </label>
        <input
          type="text"
          id="content-title-fr"
          name="subtitle"
          value={addContent.title_fr}
          onChange={(e) =>
            setAddContent({ ...addContent, title_fr: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="content-title"
          className="block text-sm font-medium text-white"
        >
          SubTitle (DE):
        </label>
        <input
          type="text"
          id="content-title-de"
          name="subtitle"
          value={addContent.title_de}
          onChange={(e) =>
            setAddContent({ ...addContent, title_de: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="content-title"
          className="block text-sm font-medium text-white"
        >
          SubTitle (IT):
        </label>
        <input
          type="text"
          id="content-title-it"
          name="subtitle"
          value={addContent.title_it}
          onChange={(e) =>
            setAddContent({ ...addContent, title_it: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="content-title"
          className="block text-sm font-medium text-white"
        >
          SubTitle (ES):
        </label>
        <input
          type="text"
          id="content-title-es"
          name="subtitle"
          value={addContent.title_es}
          onChange={(e) =>
            setAddContent({ ...addContent, title_es: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        />
        <label
          htmlFor="content"
          className="block text-sm font-medium text-white mt-4"
        >
          Content (EN):
        </label>
        <textarea
          id="content-content-en"
          name="content"
          value={addContent.content_en}
          onChange={(e) =>
            setAddContent({ ...addContent, content_en: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        ></textarea>
        <label
          htmlFor="content"
          className="block text-sm font-medium text-white mt-4"
        >
          Content (FR):
        </label>
        <textarea
          id="content-content-fr"
          name="content"
          value={addContent.content_fr}
          onChange={(e) =>
            setAddContent({ ...addContent, content_fr: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        ></textarea>
        <label
          htmlFor="content"
          className="block text-sm font-medium text-white mt-4"
        >
          Content (DE):
        </label>
        <textarea
          id="content-content-de"
          name="content"
          value={addContent.content_de}
          onChange={(e) =>
            setAddContent({ ...addContent, content_de: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        ></textarea>
        <label
          htmlFor="content"
          className="block text-sm font-medium text-white mt-4"
        >
          Content (IT):
        </label>
        <textarea
          id="content-content-it"
          name="content"
          value={addContent.content_it}
          onChange={(e) =>
            setAddContent({ ...addContent, content_it: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        ></textarea>
        <label
          htmlFor="content"
          className="block text-sm font-medium text-white mt-4"
        >
          Content (ES):
        </label>
        <textarea
          id="content-content-es"
          name="content"
          value={addContent.content_es}
          onChange={(e) =>
            setAddContent({ ...addContent, content_es: e.target.value })
          }
          required
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black"
        ></textarea>
        <div className="text-red-500 text-sm mt-2" id="news-content-error">
          {error.content}
        </div>
        <button
          type="submit"
          className="mt-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Add
        </button>
      </form>

      <div className="text-red-500 text-sm mt-2" id="news-image-error">
        {error.image}
      </div>
      <span>(click the image to change it)</span>
      {(news.image_type ?? "").startsWith("video/") ? (
        <video
          id="news-video"
          src={news.image}
          controls
          onDoubleClick={handleImageClick}
          className="cursor-pointer mt-4 max-w-full h-auto border border-gray-300 rounded-md shadow-sm min-h-24"
        />
      ) : (
        <img
          id="news-picture"
          src=""
          alt=""
          ref={imageRef}
          onClick={handleImageClick}
          className="cursor-pointer mt-4 max-w-full h-auto border border-gray-300 rounded-md shadow-sm min-h-24"
        />
      )}
    </div>
  );
};

export default NewsManagementDetails;
